export default __webpack_public_path__ + "static/media/mobileexam.0d41e5d8.svg";